export const IMAGES = {
  LOGO: `/images/unreserved-logo.png`,
  LOGO_WHITE_BG: `/images/unreserved-logo-white.png`,
  LOGIN_BG: `/images/login-hero-v2.png`,
  ONBOARDING_BG: `/images/onboarding-bg.png`,
  CHECK_EMAIL: `/images/check-email.svg`,
  PROPERTY_MODAL_CARD: `/images/property-modal-card.png`,
  CONTRACT_PROGRESS: `/images/contract-progress.png`,
  CONTRACT_SIGNED: `/images/contract-ready.png`,
  WARNING: "/images/warning.png",
  SUCCESS: "/images/success.png",
  JPG_ICON: "/images/jpg.png",
  PDF_ICON: "/images/pdf.png",
  CONFETTI: "/images/confetti.png",
  SOLD_STAMP: "/images/sold-stamp.png",
  UNAVAILABLE_STAMP: "/images/unavailable-stamp.png",
  VERIFIED_BUYER_AVATAR: "/images/verified-buyer-avatar.png",
};
